/**
 * Helpers for SyncedHorizontalScroll spacer width.
 */

/** @param {HTMLElement|null|undefined} el */
export function getScrollContentWidth(el) {
  if (!el) return 0;
  return Math.max(el.scrollWidth || 0, el.clientWidth || 0);
}

/**
 * Apply scrollLeft without feedback loop when syncing two scrollers.
 * @param {HTMLElement|null|undefined} target
 * @param {number} scrollLeft
 * @param {{current: boolean}} syncingRef
 */
export function applySyncedScrollLeft(target, scrollLeft, syncingRef) {
  if (!target || !syncingRef) return false;
  if (Math.abs((target.scrollLeft || 0) - scrollLeft) < 1) return false;
  syncingRef.current = true;
  target.scrollLeft = scrollLeft;
  // Release on next frame so the paired onScroll can ignore the echo.
  requestAnimationFrame(() => {
    syncingRef.current = false;
  });
  return true;
}
